module.exports = __webpack_public_path__ + "static/media/燴炒咖哩雞肉.5ee770a2.jpg";